module.exports = __webpack_public_path__ + "static/media/game-controller.cb7c98ec.svg";